module.exports = __webpack_public_path__ + "static/media/2.21.0a3240c2.png";